import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getDisputesCount,
  getDisputesForPaginationOrix,
} from "slices/disputeSlice";
import DisputesOrix from "./DisputesOrix";
import { usePagination } from "hooks";
import { ROWS_PER_PAGE } from "../config";

export default function DisputesContainerOrix() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile, shallowEqual);
  const user = useSelector((state) => state.user.user);

  const [count, setCount] = useState({ received: {}, registered: {} });
  const [countLoading, setCountLoading] = useState(true);
  const { page, setPage, totalPages, syncWithBackend } = usePagination({
    initialPage: 1,
    initialPageSize: ROWS_PER_PAGE,
  });

  let sessionType = sessionStorage.getItem("muthoot-type");

  const [type, setType] = useState(sessionType ? sessionType : 'open');
  const [disputes, setDisputes] = useState([]);
  const [disputesLoading, setDisputesLoading] = useState(false);
  const [region, setRegion] = useState(null);
  const [entity, setEntity] = useState('OLFS');
  const [toggleTab, setToggleTab] = useState(null);

  React.useEffect(() => {
    dispatch(getDisputesCount()).then((res) => {
      setCount(res);
      setCountLoading(false);
    });
    // reload()
  }, []);

  useEffect(()=>{
    reload(type, region, entity, toggleTab);
  },[type, region, entity, toggleTab])


  const reload = (newType = type, newRegion = region, newEntity = entity, newToggleTab = toggleTab) => {
    setDisputesLoading(true);
    setPage(1);
    dispatch(getDisputesForPaginationOrix(1, newType, newRegion, 'null', newEntity, newToggleTab)).then((res) => {
      syncWithBackend({totalCount: res?.count, next: res?.next, previous: res?.previous});
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  const getUserDataAnotherPage = (pageNo) => {
    if(pageNo === page) return;
    setPage(pageNo);
    setDisputesLoading(true);
    dispatch(getDisputesForPaginationOrix(pageNo, type, region, 'null')).then((res) => {
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  let childProps = {
    disputes,
    profile,
    user,
    count,
    countLoading,
    disputesLoading,
    setType,
    type,
    reload,
    totalPages,
    currentPage: page,
    setCurrentPage: setPage,
    getUserDataAnotherPage,
    region,
    setRegion,
    profile,
    entity,
    setEntity,
    toggleTab,
    setToggleTab,
  };

  if (countLoading) return <CircularCenteredLoader />;
  return <DisputesOrix {...childProps} />;
}
